/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';
import template from './report-template-edit-workspace.component.html';

import type {ReportTemplateGridsterResource} from './report-template-gridster-item.component';

@Component({
  standalone: false,
  selector: 'adn-report-template-edit-workspace',
  template
})
export class ReportTemplateEditWorkspaceComponent {
  @Input() reportType: string;
  @Input() components: any[] = [];
  @Input() pending = false;
  @Input() gridsterOpts: any;
  @Input() gridsterResource: ReportTemplateGridsterResource;

  readonly layoutChangeHandler = () => this.layoutChange.emit();

  @Output() addComponents = new EventEmitter<void>();
  @Output() layoutChange = new EventEmitter<void>();
}
